<template>
  <VAsync :await="request">
    <template #default="res">
      <h1>Register</h1>
      <p>Registration is currently not available</p>

      <VForm @submit.prevent="onRegister">
        <template #default="form">
          <VInput
            v-model="username"
            label="Username"
            name="username"
            required
            :disabled="res.pending"
            class="mb-3"
          />

          <VInput
            v-model="email"
            label="Email"
            name="email"
            type="email"
            :disabled="res.pending"
            class="mb-3"
          />

          <VInput
            v-model="password"
            label="Password"
            name="password"
            type="password"
            required
            :disabled="res.pending"
            class="mb-3"
          />

          <VInput
            v-model="repeat"
            label="Repeat Password"
            name="repeat"
            type="password"
            required
            :disabled="res.pending"
            class="mb-3"
          />

          <button type="submit" :disabled="!form.valid || res.pending">
            Register
          </button>

          <RouterLink :to="{ name: 'Login' }" class="btn">Login</RouterLink>
        </template>
      </VForm>
    </template>
  </VAsync>
</template>

<script>
import { API } from "../config"
import store from "../store"
import http from "../http"

export default {
  data: () => ({
    request: null,
    username: "temp",
    email: "temp@temp.co",
    password: "12345678",
    repeat: "12345678",
  }),

  methods: {
    onRegister({ target }) {
      this.request = http
        .post(`${API}/register`, {
          data: new FormData(target),
          credentials: "include",
        })
        .then(data => {
          store.set.user(data.user || {})
          store.set.auth(data.auth || {})
          this.$router.push({ name: "Dashboard" })
        })
    },
  },
}
</script>
